//Paquetes NPM de GYF. 
import { Mediator } from 'com-gyf-webcore-mediator';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, SagasProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

export const GET_SCREEN_DATA = 'GET_SCREEN_DATA';
export const GET_SCREEN_DATA_RESULT_NUEVA_SOLICITUD = 'GET_SCREEN_DATA_RESULT_NUEVA_SOLICITUD';
export const RESET_ALL = 'RESET_ALL';
export const SET_FUNCIONES_DE_USUARIO = 'SET_FUNCIONES_DE_USUARIO';
export const ADD_TARJETA_NUEVA_SOLICITUD = 'ADD_TARJETA_NUEVA_SOLICITUD';
export const CHANGE_TITULAR = 'CHANGE_TITULAR';
export const CHANGE_DOMICILIO = 'CHANGE_DOMICILIO';
export const REMOVE_TARJETA_NUEVA_SOLICITUD = 'REMOVE_TARJETA_NUEVA_SOLICITUD';
export const CHANGE_SHOW_ERROR = 'CHANGE_SHOW_ERROR';
export const CHANGE_LIMITE = 'CHANGE_LIMITE';
export const CHANGE_PRODUCTO_IBS = 'CHANGE_PRODUCTO_IBS';
export const FINALIZAR_GUARDADO = 'FINALIZAR_GUARDADO';
export const RESETE_VALUES_NEW_TARJETA = 'RESETE_VALUES_NEW_TARJETA';
export const LIMPIAR_ESTADO_NUEVA_SOLICITUD = 'LIMPIAR_ESTADO_NUEVA_SOLICITUD';
export const VALIDAR_NUEVA_SOLICITUD = 'VALIDAR_NUEVA_SOLICITUD';
export const MOSTRAR_SPINNER_GUARDADO = 'MOSTRAR_SPINNER_GUARDADO';

let _dispatch;
let _cuenta;
let _poseeTarjetas;
let _login;
let userFeatures = [];
let userFunctions = [];

/** 
 * Action que obtiene el estado inicial.
 * @param {any} state
 * @param {any} currentScope
 */
export function getScreenData(state, currentScope, cuenta, poseeTarjetas, login) {
    LogHelper.In(getScreenData.name, state, currentScope, cuenta, poseeTarjetas);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        _cuenta = cuenta;
        _poseeTarjetas = poseeTarjetas;
        _login = login;

        dispatch({ type: GET_SCREEN_DATA, state });

        Mediator.SetCallbackFunction(_loadFuncionesUsuario);
        Mediator.SetEngine1Proxy(Engine1Proxy);

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": 'TARJETAS',
            "ProgramCode": 'SOCIOS'
        }

        ConciergeProxy.Execute((data) => _loadFuncionesUsuario(data), null, "GETFUNCTIONS", currentScopeRequest);
    }
    LogHelper.Out(getScreenData.name, state, data, currentScopeRequest);
}

export function addTarjeta(tarjeta) {
    LogHelper.In(addTarjeta.name, tarjeta);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({ type: ADD_TARJETA_NUEVA_SOLICITUD, tarjeta: tarjeta });
        dispatch({ type: CHANGE_SHOW_ERROR, isError: false });
        dispatch({ type: RESETE_VALUES_NEW_TARJETA, isError: false });
    }
}

export function changeLimite(idLimite) {
    LogHelper.In(changeLimite.name, idLimite);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: CHANGE_LIMITE, idLimite: idLimite });
    }
}

export function changeProductoIbs(idProductoIbs) {
    LogHelper.In(changeProductoIbs.name, idProductoIbs);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: CHANGE_PRODUCTO_IBS, idProductoIbs: idProductoIbs });
    }
}

export function changeDomicilio(domicilio) {
    LogHelper.In(changeDomicilio.name, domicilio);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: CHANGE_DOMICILIO, domicilio: domicilio });
    }
}

export function changeResponsable(responsable) {
    LogHelper.In(changeResponsable.name, responsable);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: CHANGE_TITULAR, responsable: responsable });
    }
}

export function removeTarjeta(tarjeta) {
    LogHelper.In(removeTarjeta.name, tarjeta);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: REMOVE_TARJETA_NUEVA_SOLICITUD, idTarjeta: tarjeta });
    }
}

export function showError(isError) {
    LogHelper.In(removeTarjeta.name, isError);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: CHANGE_SHOW_ERROR, isError: isError });
    }
}

// Si el valor es undefined, retorna null, de lo contrario, retorna el valor.
function forceNullIfUndefined(value) {
    return value == undefined ? null : value;
}

export function preGuardarSolicitud(tarjetas, clienteActual, data, estadoTarjeta) {

    return (dispatch, getState) => {
        _dispatch = dispatch;

        var tarjRealizadas = [];
        let parametros = [];


        dispatch({ type: MOSTRAR_SPINNER_GUARDADO });

        tarjetas.forEach(function (item) {
            if (item.key != undefined) {

                var result = tarjRealizadas.filter(t => t === item.NumeroDocumento);
                if (result.length === 0) {
                    parametros.push({ 'DNI': item.NumeroDocumento });
                    tarjRealizadas.push(item.NumeroDocumento);
                }
            }
        });

        var jsonDocumento = JSON.stringify(parametros);

        let parameters = {
            'DOCUMENTO': jsonDocumento
        };

        var ParametrosSolicitud = {
            clienteActual: clienteActual,
            tarjetas: tarjetas,
            data: data,
            estadoTarjeta: estadoTarjeta
        };

        Engine1Proxy.AddRuleRequests(parameters, 'GETCLIENTESDATOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
        Engine1Proxy.Execute((data) => _callBackLimitesDomicilio(data, ParametrosSolicitud), null, null, "CONSULTASOCIOS");

    }

}

function _callBackLimitesDomicilio(data, parametrosSolicitud) {

    var tarjetas = parametrosSolicitud.tarjetas;

    var clientesDatos = JSON.parse(data.GETCLIENTESDATOS);

    tarjetas.forEach(function (tarjeta) {
        clientesDatos.forEach(function (cliente) {
            if ( ValueCuil( CompletDoc( tarjeta.NumeroDocumento.toString())) === ValueCuil(cliente.NumeroDocumento.toString())) {
                tarjeta.DatosFiliatorios = cliente;
            }

        });
    });

    guardarSolicitud(tarjetas, parametrosSolicitud)

}

/**
 * Crea una nueva solicitud de tarjeta.
 * @param {any} tarjetas
 * @param {any} cliente
 */
function guardarSolicitud(tarjetas, parametrosSolicitud) {
    //    LogHelper.In(guardarSolicitud.name, tarjetas, cliente);
    let tarjetasToCreate = [];
   
    const cuentasDelivery = parametrosSolicitud.estadoTarjeta.cuentasDelivery;

    let GenerarSolicitud = false;
    for (var i = 0; i < tarjetas.length; i++) {
        if (tarjetas[i].Numero.indexOf('--------') == 0)
            GenerarSolicitud = true;
    }

    if (GenerarSolicitud) {

        let darDeBajaPlasticosAntiguos = false;

        for (var i = 0; i < tarjetas.length; i++) {
            if (tarjetas[i].Numero.indexOf('--------') == 0) {
                let c = cuentasDelivery.find(x => x.CodigoCuenta == tarjetas[i].NumeroCuenta);

                let localValues = _getLocalValue(tarjetas[i], tarjetas[i].DatosFiliatorios);

                if (c !== undefined) {
                    localValues.CODIGO_SISTEMA = parseInt(c.CodigoSistema);
                    localValues.CODIGO_MONEDA = parseInt(c.CodigoMoneda);
                    localValues.SUCURSAL_ID = parseInt(c.Sucursal);
                }
                if (tarjetas[i].Activo == 2) {
                    if (tarjetas[i].Vinculo == 'Titular')
                        localValues.CODIGO_TRANSACCION = 120001
                    else
                        localValues.CODIGO_TRANSACCION = 120002
                }

                if (c.Vinculo == 6) {
                    darDeBajaPlasticosAntiguos = true
                }

                if (c.Vinculo != 1) {
                    let tarjetaTitular = tarjetas.find(x => x.Vinculo == 1);
                    if (tarjetaTitular !== undefined)
                        localValues.NUMERO_TARJETA = tarjetaTitular.Numero
                }

                localValues.VINCULO_ORIGINAL = tarjetas[i].VinculoCliente;

                tarjetasToCreate.push(localValues);
            }
        }

        if (darDeBajaPlasticosAntiguos) {
            for (var i = 0; i < tarjetas.length; i++) {
                if (tarjetas[i].Numero.indexOf('--------') == -1 && tarjetas[i].NumeroCuenta == _cuenta.CodigoCuenta) {
                    let localValues = _getLocalValueBorrado(estadoPlastico);

                    if (tarjetas[i].Vinculo == 1)
                        localValues.CODIGO_TRANSACCION = '210001';
                    else if (tarjetas[i].Vinculo == 2)
                        localValues.CODIGO_TRANSACCION = '210002';

                    let c = cuentasDelivery.find(x => x.CodigoCuenta == _cuenta.CodigoCuenta);

                    localValues.NUMERO_CUENTA = _cuenta.CodigoCuenta;
                    localValues.VINCULO_ORIGINAL = c.Vinculo;
                    localValues.NUMERO_TARJETA = tarjetas[i].Numero;
                    localValues.PRODUCTO = tarjetas[i].idProducto;
                    localValues.SUCURSAL_ID = tarjetas[i].SucursalId
                    localValues.CODIGO_LIMITE_DEBITO = tarjetas[i].CodigoLimite;
                    localValues.CODIGO_LIMITE_CREDITO = tarjetas[i].CodigoLimite;
                    if (c !== undefined) {
                        localValues.CODIGO_SISTEMA = parseInt(c.CodigoSistema);
                        localValues.CODIGO_MONEDA = parseInt(c.CodigoMoneda);
                        localValues.SUCURSAL_ID = parseInt(c.Sucursal);
                    }
                    tarjetasToCreate.push(localValues);
                }
            }
        }

        let parameters = {
            "tarjetas": tarjetasToCreate
        };

        Engine1Proxy.AddRuleRequests(parameters, 'CrearSolicitud', 'Tarjetas', 'Delivery');
        Engine1Proxy.Execute(_guardarSolicitudCallback, undefined, parametrosSolicitud.clienteActual, "DELIVERY");
    } else {
        _dispatch({ type: CHANGE_SHOW_ERROR, isError: true });
    }
    
}
/**
 * 
 */
export function reiniciarEstado() {
    LogHelper.In(reiniciarEstado.name);
    return (dispatch) => {
        dispatch({ type: LIMPIAR_ESTADO_NUEVA_SOLICITUD });
    }
}
/** ------------------------------     FUNCIONES AUXILIARES    --------------------------------  **/

function _loadFuncionesUsuario(data) {
    LogHelper.In(_loadFuncionesUsuario.name, data);

    userFeatures = JSON.parse(JSON.stringify(data)); //Todos los permisos por feature del usuario en el programa.

    if (data.DELIVERY)
        userFunctions = JSON.parse(JSON.stringify(data.DELIVERY)); //Permisos del usuario para la feature a utilizar.

    userFunctions.forEach(p => { userFunctions[p.Codigo_Funcion] = true; });

    _dispatch({ type: SET_FUNCIONES_DE_USUARIO, funciones: userFunctions, userFeatures: userFeatures });

    /*Si tiene permisos sobre la consulta de la pantalla, hago el resto de las llamadas*/
    if (userFunctions.Consulta == true) {

        let parametroIBS = {
            CODIGO_INTERNO: parseInt(_cuenta.CodigoProducto)
        }

        Engine1Proxy.AddDataSourcesRequests(null, 'GET_LIMITES_DEB_CRED', 'Get', 'Tarjetas', 'Delivery', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(parametroIBS, 'GET_PRODUCTOS_IBS', 'Get', 'Tarjetas', 'Delivery', 1, 'Product');

        let parametrosWs = {
            usrTipdoc: "88",
            usrIdent: "11111111",
            usrPassword: "frame7890*",
            encoding: "UTF8",
            sucursal: _cuenta.Sucursal,
            codigoSistema: "5",
            moneda: _cuenta.CodigoMoneda,
            cuenta: _cuenta.CodigoCuenta
        }

        //if (_poseeTarjetas)
        Engine1Proxy.AddRuleRequests(parametrosWs, 'GetResponsables', 'Tarjetas', 'Delivery');

        Engine1Proxy.Execute(_screenDataResult, null, null, "DELIVERY");
    }

    LogHelper.Out(_loadFuncionesUsuario.name, data);
}

function _screenDataResult(data) {
    LogHelper.In(_screenDataResult.name, data);

    let result = {
        limites: JSON.parse(data['GET_LIMITES_DEB_CRED']).Recordset0.Rows,
        productosIbs: JSON.parse(data['GET_PRODUCTOS_IBS']).Recordset0.Rows,
        responsables: data.GetResponsables == undefined ? undefined : JSON.parse(data.GetResponsables)
    }

    if (result.responsables !== undefined) {
        for (var i = 0; i < result.responsables.length; i++) {
            let parametro = {
                'NRO_DOC': parseInt(result.responsables[i].NroDoc)
            }
            Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_PLASTICO_BY_NRO_DOC', 'Get', 'Tarjetas', 'Delivery', 1, 'Product', true, result.responsables[i].NroDoc);
        }
        Engine1Proxy.Execute(_getTarjetasResponsables, null, result, "DELIVERY");
    } else {
        _dispatch({
            type: GET_SCREEN_DATA_RESULT_NUEVA_SOLICITUD,
            result: result,
            cuenta: _cuenta
        });
    }
}

function _getTarjetasResponsables(data) {


    for (var i = 0; i < data.CALLER_ID.responsables.length; i++) {
        var result_tarjetas_by_numDoc = JSON.parse(data[data.CALLER_ID.responsables[i].NroDoc.toString()]).Recordset0.Rows;

        result_tarjetas_by_numDoc.forEach(function (item) {

            if (data.hasOwnProperty(data.CALLER_ID.responsables[i].NroDoc.toString()) && item.Activo == 1) {
                data.CALLER_ID.responsables[i].PoseeTarjetas = true;
            } else {
                data.CALLER_ID.responsables[i].PoseeTarjetas = false;
            }
        });
    }

    _dispatch({
        type: GET_SCREEN_DATA_RESULT_NUEVA_SOLICITUD,
        result: data.CALLER_ID,
        cuenta: _cuenta
    });
}

function _guardarSolicitudCallback(data) {
    LogHelper.In(_guardarSolicitudCallback.name, data);
    let cliente = data.CALLER_ID;
    let parameters = {
        CLIENTE_BANCO_NUMERO: forceNullIfUndefined(cliente.ClienteBancoNumero),
        APELLIDO: forceNullIfUndefined(cliente.Apellido),
        NOMBRE: forceNullIfUndefined(cliente.Nombre),
        RAZON_SOCIAL: forceNullIfUndefined(cliente.RazonSocial),
        FISICA_JURIDICA: forceNullIfUndefined(cliente.FisicaJuridica),
        TIPO_DOCUMENTO_ID: forceNullIfUndefined(cliente.TipoDocumento.Id),
        TIPO_DOCUMENTO_CODIGO: forceNullIfUndefined(cliente.TipoDocumentoCodigo),
        NUMERO_DOCUMENTO: forceNullIfUndefined(cliente.NumeroDocumento),
        CUIT: forceNullIfUndefined(cliente.Cuit),
        FECHA_NACIMIENTO: forceNullIfUndefined(cliente.FechaNacimiento),
        CATEGORIA_IVA_ID: forceNullIfUndefined(cliente.CategoriaIVA),
        TIPO_IIBB_ID: forceNullIfUndefined(cliente.TipoIIBB),
        NACIONALIDAD_ID: forceNullIfUndefined(cliente.Nacionalidad.Id),
        OCUPACION_ID: forceNullIfUndefined(cliente.Ocupacion),
        ESTADO_CIVIL_ID: forceNullIfUndefined(cliente.EstadoCivil.Id),
        SEXO: forceNullIfUndefined(cliente.Sexo),
        SOLICITUD_ID: forceNullIfUndefined(data.CrearSolicitud)
    };

    Engine1Proxy.AddRuleRequests(parameters, 'CrearModificarClienteDelivery', 'Tarjetas', 'Delivery');
    Engine1Proxy.Execute(_CrearModificarClienteDeliveryCallback);

    //Descomentar cuando se use SAGAS...
    //SagasProxy.AddSagaRequests(localValues, 'CREAR_MODIFICAR_CLIENTE', "TARJETAS", "DELIVERY");
    //SagasProxy.Execute(_CrearModificarClienteDeliveryCallback, undefined, undefined, "DELIVERY");

    LogHelper.Out(_guardarSolicitudCallback.name, data);
}

function _CrearModificarClienteDeliveryCallback() {
    LogHelper.In(_CrearModificarClienteDeliveryCallback.name);

    _dispatch({
        type: FINALIZAR_GUARDADO
    });
}

function _getLocalValue(tarjetas, cliente) {
    var NDoc = cliente.NumeroDocumento.toString();
    let localValues = {
        SUCURSAL: forceNullIfUndefined(tarjetas.SucursalId),
        PRODUCTO: forceNullIfUndefined(tarjetas.ProductoId),
        NUMERO_CUENTA: forceNullIfUndefined(tarjetas.NumeroCuenta),
        CALLE: forceNullIfUndefined(tarjetas.domicilioResponsable.CALLE),
        NUMERO: forceNullIfUndefined(tarjetas.domicilioResponsable.NUMERO_CALLE),
        PISO: forceNullIfUndefined(tarjetas.domicilioResponsable.PISO),
        DEPARTAMENTO: forceNullIfUndefined(tarjetas.domicilioResponsable.DEPTO),
        LOCALIDAD: forceNullIfUndefined(tarjetas.domicilioResponsable.DESC_LOCALIDAD),
        CODIGO_POSTAL: forceNullIfUndefined(tarjetas.domicilioResponsable.CODIGO_POSTAL),
        TELEFONO: forceNullIfUndefined(tarjetas.domicilioResponsable.TELEFONO),
        NUMERO_DOCUMENTO: cliente.NumeroDocumento,
        APELLIDO: forceNullIfUndefined(cliente.Apellido),
        NOMBRE: forceNullIfUndefined(cliente.Nombre),
        SEXO: forceNullIfUndefined(cliente.Sexo),
        CODIGO: forceNullIfUndefined(cliente.TipoDocumento.Id),
        DIGITO_VERIFICADOR: NDoc.substring(10, 11),
        OCUPACION: forceNullIfUndefined(tarjetas.domicilioResponsable.DESC_PROFESION),
        FECHA_NACIMIENTO: forceNullIfUndefined(cliente.FechaNacimiento),
        ESTADO_CIVIL: cliente.EstadoCivil == undefined || cliente.EstadoCivil == null ? " " : cliente.EstadoCivil.Codigo.charAt(0),
        NACIONALIDAD: cliente.Nacionalidad == undefined || cliente.Nacionalidad.Codigo == null ? "               " : cliente.Nacionalidad.Codigo,
        TIPO_DOCUMENTO: forceNullIfUndefined(cliente.TipoDocumento.Codigo),
        CATEGORIA_CONSUMIDOR: "00",
        CODIGO_LIMITE_DEBITO: forceNullIfUndefined(tarjetas.LimiteId),
        CODIGO_LIMITE_CREDITO: forceNullIfUndefined(tarjetas.LimiteId),
        GRUPO_AFINIDAD: "M", // TODO
        TIPO_CUENTA: "M", // NO APLICA, DEJAR ASI...
        LOGIN: _login,
        CODIGO_TRANSACCION: 1,
        NUMERO_TARJETA: "0000000000000000000",
        CODIGO_SISTEMA: 0,
        CODIGO_MONEDA: 0,
        SUCURSAL_ID: null,
        VINCULO_ORIGINAL: 0
    };
    return localValues;
}

function _getLocalValueBorrado(estadoPlastico) {

    let date = new Date();
    let nroDoc = estadoPlastico.clienteResultadoBusqueda.NumeroDocumento.toString();

    return {
        SUCURSAL: "M",
        PRODUCTO: 1,
        NUMERO_CUENTA: 0,
        CALLE: forceNullIfUndefined(estadoPlastico.domicilios[1].CALLE),
        NUMERO: forceNullIfUndefined(estadoPlastico.domicilios[1].NUMERO_CALLE),
        PISO: forceNullIfUndefined(estadoPlastico.domicilios[1].PISO),
        DEPARTAMENTO: forceNullIfUndefined(estadoPlastico.domicilios[1].DEPTO),
        LOCALIDAD: forceNullIfUndefined(estadoPlastico.domicilios[1].LOCALIDAD),
        CODIGO_POSTAL: forceNullIfUndefined(estadoPlastico.domicilios[1].CODIGO_POSTAL),
        TELEFONO: forceNullIfUndefined(estadoPlastico.domicilios[1].TELEFONO),
        NUMERO_DOCUMENTO: forceNullIfUndefined(nroDoc.substring(2, 10)),
        APELLIDO: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.Apellido),
        NOMBRE: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.Nombre),
        SEXO: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.Sexo),
        CODIGO: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.TipoDocumento.Id),
        DIGITO_VERIFICADOR: forceNullIfUndefined(nroDoc.substring(10, 11)),
        OCUPACION: "M",
        FECHA_NACIMIENTO: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.FechaNacimiento),
        ESTADO_CIVIL: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.EstadoCivil !== null ? estadoPlastico.clienteResultadoBusqueda.EstadoCivil.Codigo : null),
        NACIONALIDAD: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.Nacionalidad !== null ? estadoPlastico.clienteResultadoBusqueda.Nacionalidad.Codigo : null),
        TIPO_DOCUMENTO: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.TipoDocumento.Codigo),
        CATEGORIA_CONSUMIDOR: "00",
        CODIGO_LIMITE_DEBITO: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.Limite),
        CODIGO_LIMITE_CREDITO: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.Limite),
        GRUPO_AFINIDAD: "M", //NO APLCA...
        TIPO_CUENTA: "M", //NO APLICA...
        LOGIN: _login,
        CODIGO_TRANSACCION: 1,
        NUMERO_TARJETA: "0000000000000000000",
        CODIGO_SISTEMA: 0,
        CODIGO_MONEDA: 0,
        SUCURSAL_ID: 0,
        NRO_ORIGINAL: null,
        VINCULO_ORIGINAL: 0
    };
}

function ValueCuil(value) {
    if (value.length == 11) {
        value = value.slice(2, -1);
    }
    return value;
}

function CompletDoc( value ) {
    if ( value.length == 7 ) {
        value = '0' + value;

    }

    return value;
}